import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  OnInit,
} from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { interval, Observable, of } from 'rxjs';
import { filter, map, startWith, switchMap } from 'rxjs/operators';
import { TimerService } from './timer.service';

@Component({
  selector: 'h3-timer-badge',
  templateUrl: './timer-badge.component.html',
  styleUrls: ['./timer-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TimerBadgeComponent extends DirectiveSuperclass implements OnInit {
  // Observable is required to trigger change detection
  data$!: Observable<{
    contextualClass: string;
    currentDuration?: number;
    shouldShow: boolean;
    targetDuration?: number;
  }>;

  constructor(
    private timerService: TimerService,
    injector: Injector,
  ) {
    super(injector);
  }

  ngOnInit() {
    const duration$ = this.timerService.status$.pipe(
      filter((status) => status !== 'stopped'),
      switchMap((status) => {
        if (status === 'paused') {
          return of(this.timerService.elapsed());
        }

        return interval(1000).pipe(
          startWith(0),
          map(() => this.timerService.elapsed()),
        );
      }),
    );

    this.data$ = duration$.pipe(
      map((currentDuration) => {
        if (!this.timerService.isVisible) {
          return { shouldShow: false, contextualClass: '' };
        }

        return {
          shouldShow: this.timerService.isVisible,
          targetDuration: this.timerService.targetDuration,
          currentDuration,
          contextualClass: this.convertDurationToContextualClass(
            currentDuration,
            this.timerService.targetDuration,
          ),
        };
      }),
    );
  }

  private convertDurationToContextualClass(
    currentDuration: number,
    targetDuration: number,
  ) {
    if (currentDuration >= targetDuration) {
      return 'alert-danger';
    } else if (currentDuration >= targetDuration * 0.9) {
      return 'alert-warning';
    } else {
      return 'alert-info';
    }
  }
}
